import { Component, Input, TemplateRef, ChangeDetectionStrategy } from '@angular/core';

// TODO: ONPUSH

@Component({
  standalone: false,
  selector: 'lib-detail-layout',
  templateUrl: './detail-layout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./detail-layout.component.scss']
})
export class DetailLayoutComponent {
  @Input() detailHeader: TemplateRef<any>;
  @Input() detailBreadcrumbs: TemplateRef<any>;
  @Input() detailMenu: TemplateRef<any>;
  @Input() detailContent: TemplateRef<any>;
}
